<template>
  <!-- eslint-disable max-len -->
  <!-- <div class="alert text-center fixed-bottom" :class="alertClass" v-if="flashMessage">{{ flashMessage }}</div> -->
  <!-- TODO: determine if/how flashStyle should be incorporated into the "modal" mode -->
  <b-modal
    v-model="showModal"
    ok-only
    hide-header
    @hidden="onHidden"
  >{{ flashMessage }}</b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapGetters([
      'flashMessage',
      'flashStyle',
      'flashDuration',
      'flashIsModal',
      'flashOnCloseModal',
      'flashSubmitter',
    ]),
    alertClass() {
      return `alert-${this.flashStyle || 'success'}`;
    },
    doMobileBehavior() {
      const { clientWidth, clientHeight } = document.documentElement;
      return clientWidth < 779 && clientHeight < 779 && /mobi|android/i.test(navigator.userAgent);
    }
  },
  watch: {
    flashSubmitter() {
      // this watcher triggers the notification
      // if not modal mode, it will use a dynamic bootstrap vue toast
      // if modal mode, and not on a mobile device, it will use a static bootstrap vue modal
      // if modal mode, and on a mobile device, it will use a browser-level alert
      if (this.flashMessage) {
        if (!(this.flashIsModal)) {
          this.$bvToast.toast(' ',
            {
              toaster: 'b-toaster-top-center',
              title: this.flashMessage,
              variant: this.flashStyle,
              autoHideDelay: this.flashDuration,
              bodyClass: 'no-body',
            });
        } else if (this.doMobileBehavior) {
          // eslint-disable-next-line no-alert
          alert(this.flashMessage);
          if (this.flashOnCloseModal) {
            this.flashOnCloseModal();
          }
        } else {
          this.showModal = true;
        }
      }
    }
  },
  methods: {
    onHidden() {
      console.log(this.flashOnCloseModal);
      if (this.flashOnCloseModal) {
        this.flashOnCloseModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Flash.vue